import { render } from "./ChangeExcessStep.vue?vue&type=template&id=3a0c1346"
import script from "./ChangeExcessStep.vue?vue&type=script&lang=js"
export * from "./ChangeExcessStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__